var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.isPC ? _c('div', {
    staticClass: "feedback-dialog"
  }, [_c('div', {
    staticClass: "feedback-dialog-main"
  }, [_c('div', {
    staticClass: "feedback-dialog-header"
  }, [_c('div', {
    staticClass: "dialog-header-container"
  }, [_c('span', {
    staticClass: "dialog-header-title"
  }, [_vm._v(" " + _vm._s(_vm.TUITranslateService.t("AIDesk.感谢您的反馈，我们会持续优化改进")) + " ")])]), _c('div', {
    on: {
      "click": _vm.closeFeedbackModal
    }
  }, [_c('Icon', {
    attrs: {
      "file": _vm.DialogCloseIcon,
      "width": "20px",
      "height": "20px"
    }
  })], 1)]), _c('div', {
    staticClass: "dialog-select-container"
  }, [_c('span', {
    staticClass: "dialog-session-title"
  }, [_vm._v(" " + _vm._s(_vm.TUITranslateService.t("AIDesk.您遇到了哪方面的问题")) + " ")]), _c('div', {
    staticClass: "dialog-button-list"
  }, _vm._l(_vm.feedbackButtonList, function (item) {
    return _c('div', {
      staticClass: "dialog-button-row"
    }, [_c('div', {
      class: ['dialog-button', item.isSelected ? 'dialog-button-selected' : ''],
      on: {
        "click": function ($event) {
          return _vm.dialogButtonClick(item);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.feedbackButtonListFromStore ? item.content : _vm.TUITranslateService.t(("AIDesk." + (item.content)))) + " ")])]);
  }), 0)]), _c('div', {
    staticClass: "dialog-other-feedback-container"
  }, [_c('span', {
    staticClass: "dialog-session-title"
  }, [_vm._v(" " + _vm._s(_vm.TUITranslateService.t("AIDesk.其他反馈内容")) + " ")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.feedbackText,
      expression: "feedbackText"
    }],
    staticClass: "dialog-other-feedback-input",
    attrs: {
      "type": "text",
      "placeholder": _vm.TUITranslateService.t('AIDesk.我们想知道你对此回答不满意的原因，你认为更好的回答是什么？'),
      "maxlength": "200"
    },
    domProps: {
      "value": _vm.feedbackText
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.feedbackText = $event.target.value;
      }
    }
  })]), _c('div', {
    staticClass: "dialog-foot"
  }, [_c('div', {
    class: _vm.isSubmitEnabled ? 'dialog-submit' : 'dialog-submit disabled',
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" " + _vm._s(_vm.TUITranslateService.t("AIDesk.提交")) + " ")]), _c('div', {
    staticClass: "dialog-cancel",
    on: {
      "click": _vm.closeFeedbackModal
    }
  }, [_vm._v(" " + _vm._s(_vm.TUITranslateService.t("AIDesk.取消")) + " ")])])])]) : _c('div', {
    staticClass: "edit-form"
  }, [_c('div', {
    staticClass: "edit-form-item"
  }, [_c('FormPopup', {
    staticClass: "form-item",
    attrs: {
      "show": true,
      "showHeaderCloseButton": false,
      "title": ""
    },
    on: {
      "onClose": _vm.closeFeedbackModal
    }
  }, [_c('div', {
    staticClass: "dialog-title"
  }, [_c('div', {
    staticClass: "dialog-header-title"
  }, [_vm._v(" " + _vm._s(_vm.TUITranslateService.t("AIDesk.感谢您的反馈，我们会持续优化改进")) + " ")]), _c('Icon', {
    attrs: {
      "file": _vm.DialogCloseIcon,
      "width": "16px",
      "height": "16px"
    },
    on: {
      "click": _vm.closeFeedbackModal
    }
  })], 1), _c('div', {
    staticClass: "dialog-select-container-h5"
  }, [_c('span', {
    staticClass: "dialog-session-title"
  }, [_vm._v(" " + _vm._s(_vm.TUITranslateService.t("AIDesk.您遇到了哪方面的问题")) + " ")]), _c('div', {
    staticClass: "dialog-button-list"
  }, _vm._l(_vm.feedbackButtonList, function (item) {
    return _c('div', {
      staticClass: "dialog-button-row"
    }, [_c('div', {
      class: ['dialog-button', item.isSelected ? 'dialog-button-selected' : ''],
      on: {
        "click": function ($event) {
          return _vm.dialogButtonClick(item);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.feedbackButtonListFromStore ? item.content : _vm.TUITranslateService.t(("AIDesk." + (item.content)))) + " ")])]);
  }), 0)]), _c('div', {
    staticClass: "dialog-other-feedback-container-h5"
  }, [_c('span', {
    staticClass: "dialog-session-title"
  }, [_vm._v(" " + _vm._s(_vm.TUITranslateService.t("AIDesk.其他反馈内容")) + " ")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.feedbackText,
      expression: "feedbackText"
    }],
    staticClass: "dialog-other-feedback-input",
    attrs: {
      "type": "text",
      "placeholder": _vm.TUITranslateService.t('AIDesk.我们想知道你对此回答不满意的原因，你认为更好的回答是什么？'),
      "maxlength": "200"
    },
    domProps: {
      "value": _vm.feedbackText
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.feedbackText = $event.target.value;
      }
    }
  })]), _c('div', {
    staticClass: "dialog-foot-h5"
  }, [_c('div', {
    class: _vm.isSubmitEnabled ? 'dialog-submit' : 'dialog-submit disabled',
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" " + _vm._s(_vm.TUITranslateService.t("AIDesk.提交")) + " ")])])])], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }